<template>
  <div class="node-panel">
    <div class="header">
      <v-row class="no-padding">
        <v-col
          cols="auto"
          class="mr-auto"
        >
         <span>Destination</span>
        </v-col>

        <v-col cols="auto">
          <div class="icon-container">
            <svg 
              height='25px' 
              width='25px' 
              :fill="nodeActive"
              xmlns="http://www.w3.org/2000/svg" 
              viewBox="0 0 619 619"
              @click="setViewFormat('node')"
            >
              <path d="M596 399h-42v-57c0-27.6-22.4-50-50-50h-173v-67h42c13.8 0 25-11.2 25-25v-125c0-13.8-11.2-25-25-25h-125c-13.8 0-25 11.2-25 25v125c0 13.8 11.2 25 25 25h43v67h-173c-27.6 0-50 22.4-50 50l-.2 57h-42.8c-13.8 0-25 11.2-25 25v125c0 13.8 11.2 25 25 25h125c13.8 0 25-11.2 25-25v-125c0-13.8-11.2-25-25-25h-42.2l.2-57c0-5.5 4.5-10 10-10h173v67h-43c-13.8 0-25 11.2-25 25v125c0 13.8 11.2 25 25 25h125c13.8 0 25-11.2 25-25v-125c0-13.8-11.2-25-25-25h-42v-67h173c5.5 0 10 4.5 10 10v57h-43c-13.8 0-25 11.2-25 25v125c0 13.8 11.2 25 25 25h125c13.8 0 25-11.2 25-25v-125c0-13.8-11.2-25-25-25z"></path>
            </svg>
          </div>
        </v-col>

        <v-col cols="auto">
          <div class="icon-container">  
            <v-icon 
              :color="vehicleActive"
              medium
              @click="setViewFormat('list')">
              mdi-format-list-bulleted-square
            </v-icon>
          </div>  
        </v-col>
      </v-row>
    </div>
    <div class="content" :class="{ overflow : !isNodeView }">
      <pvcam-wc-device-manager
        v-if="isNodeView"
        vehicle
        :org="orgId"
        :org-id="orgId"
        :org-name="orgName"
        :outsideclick="outsideClick"
        :reenter="false"
        :user-node="''"
        class="node-view"
        :class="{ hide : loading }"
        @autocomplete="autocomplete"
      ></pvcam-wc-device-manager>			
      <div
        v-else
        class="list-view"
        :class="{ hide : loading }"
      >
        <v-list dense>
          <v-text-field
            v-model="search"
            label="Search"
            prepend-icon="mdi-magnify"
          ></v-text-field>
          <v-list-item-group
            v-model="listSelection"
            color="primary"
          >
            <v-list-item
              v-for="(item, i) in filteredVehicles"
              :key="i"
              :value="item.id"
            >
              <v-list-item-icon>
                <v-icon :ref="item.id + '_list'" :color="iconColour(item)">mdi-car</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title v-text="item.vehicle_name"></v-list-item-title>
              </v-list-item-content>
              <v-list-item-content>
                <v-list-item-title v-text="item.group_name"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </div>
      <v-container v-if="loading" class="loading-container" fill-height>
        <v-row justify="center" align="center">
          <v-col class="center-text" cols="12" sm="4">
            <v-progress-circular
              indeterminate
              large
              color="blue"
            ></v-progress-circular>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>

import { Logger } from "aws-amplify"
const logger = new Logger("Device Assignment")

import { GetOrgVehicles, GetOrgTree } from "@/services/API.js";

export default {
  name: 'NodePanel',
  props: {
    orgId: {
      type: String,
      required: true
    },
    orgs: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      targetNode: '',
      selectedViewFormat: null,
      outsideClick: 0,
      orgVehicles: [],
      orgTree: {},
      listSelection: [],
      search: '',
      loading: true
    }
  },
  computed: {
    isNodeView() {
      return this.selectedViewFormat == 'node' ? true : false;
    },
    nodeActive() {
      return this.selectedViewFormat == 'node' ? '#0069bb' : '#fff';
    },
    vehicleActive() {
      return this.selectedViewFormat == 'list' ? '#0069bb' : '#fff';
    },
    orgName() {
      let org = this.orgs.find(org => {
        return org.id == this.orgId;
      });

      return org.name;
    },
    filteredVehicles() {
      if (this.search.length > 0) {
        let filteredItems = this.orgVehicles.filter(item => {
          return item.vehicle_name.toLowerCase().includes(this.search.toLowerCase()) || item.group_name.toLowerCase().includes(this.search.toLowerCase())
        });

        return filteredItems;
      } 
      else {
        return this.orgVehicles;
      }
    }
  },
  watch: {
    selectedViewFormat() {
      if (this.selectedViewFormat == 'list') {
        this.loading = true;

        this.fetchOrgTree();
        this.fetchOrgVehicles();
      }
    },
    listSelection(val) {
      let target = this.orgVehicles.find(item => item.id == val);

      this.$emit('installTargetListSelected', [target]);
    }
  },
  mounted() {
    // Set default node tree as default view
    this.selectedViewFormat = 'node';
    window.EventBus.$on('initTargetDeviceManager', this.handleLoading);
    window.EventBus.$on('targetsForAssignment', this.highlistListViewTargets)
  },
  methods: {
    handleLoading() {
      this.loading = false;
    },
    autocomplete() {},
    iconColour(item) {
			return item.devices.length > 0 ? 'red' : 'rgb(0, 105, 187)';
    },
    setTarget(e) {
      if (e.detail.length > 0 && e.detail[0]) this.targetNode = e.detail[0]
    },
    fetchOrgVehicles() {
      GetOrgVehicles(this.orgId, true)
      .then(res => {
        this.orgVehicles = res;

        // Add group name and target mapping
        this.orgVehicles.forEach(vehicle => {
          vehicle.group_name = this.returnVehicleGroup(vehicle.node, this.orgTree.root_node).metadata.label;
          vehicle.target = vehicle.vehicle_name;
        });
        
        this.loading = false;
      })
      .catch(err => {
        logger.info('org vehicles failed : ', err);
      })
    },
    fetchOrgTree() {
      logger.info('fetch Org Tree')
      GetOrgTree(this.orgId)
      .then(res => {
        this.orgTree = res;
      })
      .catch(err => {
        logger.info('Error fetching node tree : ', err);
      });
    },
    setViewFormat(target) {
      this.selectedViewFormat = target;
    },
    returnVehicleGroup(id, node) {
      let result;

      if (Object.values(node).indexOf(id) > -1) {
        return node;
      } else {
        for (var i = 0; i < node.nodes.length; i += 1) {
          let subNode = node.nodes[i];
          
          result = this.returnVehicleGroup(id, subNode);

          if (result !== false) {
              return result;
          }
        }
        return false;
      }
    },
    highlistListViewTargets(data) { 
      if (this.selectedViewFormat == 'list') {
        data[0].target.forEach(item => {
          let target = `${item.id}_list`;
          let comp = this.$refs[target];

          if (comp) {
            comp[0].$el.classList.toggle('highlighted');
          }
        });
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .node-panel {
    height: 100%;
    background: white;
    border: solid 1px black;
    margin-right: 1em;
    .header {
      background: #e0e0e0;
      .icons {
        float: right;
      }
      .icon-container {
        &:hover {
          cursor: pointer;
        }
      }
    }
    .content {
      height: 650px;
      padding: 0.5em .75em;
    }
    .list-view {
      padding: 0;
    }
    .overflow {
      overflow: scroll;
    }
  }
  .no-padding {
    padding: 0 !important;
    margin: 0 !important;
  }
  .center-text {
    text-align: center;
  }
  .hide {
    display: none !important;
  }
  .highlighted {
    color: orange !important;
  }
</style>